import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type TransferAction } from './constants'
import TransferForm from './TransferForm'

export default function TransferModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('transfer')

  const formByAction = {
    send: TransferForm,
  } satisfies Record<TransferAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='transfer' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
